import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://otrlfeknxyqmziswdzvj.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im90cmxmZWtueHlxbXppc3dkenZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ3MDM1MTEsImV4cCI6MjA3MDI3OTUxMX0.5NsjONo4UKh-9AcmTYXmsFK3oFF6glnVkk4ISKxO4iA';

if (SUPABASE_URL === 'https://YOUR_PROJECT_ID.supabase.co' || SUPABASE_ANON_KEY === 'YOUR_ANON_KEY') {
  throw new Error('Missing Supabase variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

export default supabase;